import React, { ReactNode } from 'react'
import { useAppTranslation } from '../../../../hooks/useAppTranslation'
import { MarketplaceItem } from './MarketplaceItem'
import { PostCallout } from '../PostCallout'
import { PostResourceCard } from '../../../../generated/api/post-row'

interface PostResourcesProps {
  resources: PostResourceCard[]
}

export const PostResources = ({ resources }: PostResourcesProps): ReactNode => {
  const { translate } = useAppTranslation()

  if (resources.length === 0) {
    return null
  }

  return (
    <div className="flex w-full flex-col gap-4">
      <PostCallout text={translate('post.newMarketPlaceItemText')} />
      {resources.map((resource) => (
        <MarketplaceItem key={resource.id} resource={resource} />
      ))}
    </div>
  )
}
